var map = {
	"./alternative.png": 912,
	"./ambient.png": 913,
	"./blues.png": 914,
	"./christian_&_gospel.png": 915,
	"./classical.png": 916,
	"./country.png": 917,
	"./dance_EDM.png": 918,
	"./dancehall.png": 919,
	"./deephouse.png": 920,
	"./disco.png": 921,
	"./drum_&_bass.png": 922,
	"./dub.png": 923,
	"./dubstep.png": 924,
	"./electronic.png": 925,
	"./folk.png": 926,
	"./hardcore.png": 927,
	"./house.png": 928,
	"./indie.png": 929,
	"./jazz.png": 930,
	"./jrock.png": 931,
	"./kpop.png": 932,
	"./latin.png": 933,
	"./metal.png": 934,
	"./pop.png": 935,
	"./punk.png": 936,
	"./r&b_soul.png": 937,
	"./rap.png": 938,
	"./reggae.png": 939,
	"./reggaeton.png": 940,
	"./rock.png": 941,
	"./singer_songwriter.png": 942,
	"./soundtrack.png": 943,
	"./techno.png": 944,
	"./trance.png": 945,
	"./trap.png": 946,
	"./trip_hop.png": 947,
	"./world.png": 948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 911;